/**
 * Make an error from an unknown value. The original exception will be added to the error object.
 * @param error - The unknown value to make an error from
 * @returns The error
 */
export default function makeErrorFromUnknown(error: unknown): Error {
  if (error instanceof Error) return error;
  const err = new Error(String(error));
  // @ts-expect-error - We are adding a new property to the error object;
  err.originalException = error;
  return err;
}
